import React, { useMemo, useState } from "react";
import { Truck, Plus, FileText } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import {
  useAddIftaTripEntryMutation,
  useAddIftaTripEntryPublicMutation,
  useGetFuelRatesQuery,
  useGetIftaDetailPublicQuery,
  useGetIftaDetailQuery,
} from "../../redux/services/IftaComplianceService";
import { responseError } from "../../helpers/responseHandler";
import { sweetAlert } from "../../utils";

export default function IftaPublicUrl() {
  const params = useParams();
  const { data, isLoading } = useGetFuelRatesQuery();
  const {
    data: data2,
    isLoading: isLoading2,
    isFetching,
    refetch,
  } = useGetIftaDetailPublicQuery({ id: params?.id });

  const [addRequest, { isLoading: isAdding }] =
    useAddIftaTripEntryPublicMutation();

  const QUARTERLY_RATES = useMemo(
    () => data?.response?.data || {},
    [data?.response?.data],
  );
  const iftaDetails = useMemo(
    () => data2?.response?.data || {},
    [data2?.response?.data],
  );

  const [activeTab, setActiveTab] = useState("add");
  const [selectedState, setSelectedState] = useState("");
  const [miles, setMiles] = useState("");
  const [gallons, setGallons] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);

  const report = {
    truckId: "TX-9087",
    quarter: "Q1767609980272",
    year: 2025,
    entries: [
      {
        id: 1,
        state: "WE",
        miles: 34,
        gallons: 34,
        createdAt: "2026-01-03T19:46:00",
      },
      {
        id: 2,
        state: "HG",
        miles: 23,
        gallons: 1000,
        createdAt: "2026-01-03T19:46:20",
      },
      {
        id: 3,
        state: "NM",
        miles: 600,
        gallons: 80,
        createdAt: "2026-01-03T19:47:00",
      },
    ],
  };

  const formatDate = (iso) => {
    return new Date(iso).toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  };

  const handleAddTrip = async (rates) => {
    if (!selectedState || !miles || !gallons) return;
    const rate = rates?.find((r) => r.state_name == selectedState);

    const data = {
      i_f_t_a_filling_id: params?.id,
      state: selectedState,
      miles: miles,
      gallons: gallons,
    };
    if (rate?.id) {
      data["tax_rate_id"] = rate?.id;
    }

    await addRequest({ form: data, slug: params?.id })
      .unwrap()
      .then((res) => {
        console.log("res", res);
        if (res?.status) {
          setShowSuccess(true);
          setSelectedState("");
          setMiles("");
          setGallons("");

          // setRows([...rows, { id: newId, jurisdiction: 'AL', miles: '0', taxPaidGallons: '0' }]);
        }
      })
      .catch((err) => {
        console.log("err", err);
        responseError(err);
      })
      .finally(() => {
        setTimeout(() => {
          setShowSuccess(false);
        }, 3000);
        // Reset Fields
      });
  };

  if (isLoading || isLoading2) {
    return <div>Loading...</div>;
  }

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 bg-light overflow-auto public_url"
      style={{ zIndex: 9999 }}
    >
      <div className="bg-primary text-white px-3 py-2 d-flex justify-content-between align-items-center position-sticky top-0">
        <span className="fw-bold small">Drivers View (Static Preview)</span>

        <Link
          to="/ifta-compliance-view/1"
          className="text-white-50 text-decoration-underline border-0 bg-transparent small custome-text"
        >
          Return to Admin
        </Link>
      </div>

      <div className="container my-3 shadow bg-white p-0 custom_height ">
        <div className="top">
          <div className="bg-dark text-white p-4 shadow-sm custom-radius">
            <div className="d-flex align-items-center mb-2 opacity-75">
              <Truck size={20} className="me-2" />
              <span className="fw-bold">Truklex IFTA</span>
            </div>

            <h3 className="fw-bold mb-1">Add Trip Data</h3>
            <small className="text-white-50">
              {report.truckId} • {report.quarter} {report.year}
            </small>
          </div>

          {showSuccess && (
            <div className="mx-4 mt-4 p-3 d-flex align-items-center text-success bg-success bg-opacity-10 fw-medium bounce-animation">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="me-2"
              >
                <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                <path d="m9 11 3 3L22 4"></path>
              </svg>
              Entry Added Successfully!
            </div>
          )}

          <div className="p-4">
            {activeTab === "add" ? (
              <div>
                <label className="fw-bold small text-secondary">
                  State / Jurisdiction
                </label>

                <select
                  value={selectedState}
                  onChange={(e) => setSelectedState(e.target.value)}
                  className="form-select"
                >
                  <option value="">Please Select State</option>
                  {QUARTERLY_RATES.map((item) => (
                    <option key={item.id} value={item?.state_name}>
                      {item.state_code} – {item.state_name}
                    </option>
                  ))}
                </select>

                <div className="mt-3">
                  <label className="fw-bold small text-secondary">
                    Total Miles Driven
                  </label>
                  <input
                    type="number"
                    className="form-control p-3"
                    placeholder="0"
                    value={miles}
                    onChange={(e) => setMiles(e.target.value)}
                  />
                </div>

                <div className="mt-3">
                  <label className="fw-bold small text-secondary">
                    Fuel Purchased (Gallons)
                  </label>
                  <input
                    type="number"
                    className="form-control p-3"
                    placeholder="0"
                    value={gallons}
                    onChange={(e) => setGallons(e.target.value)}
                  />
                </div>

                <button
                  className="btn btn-primary w-100 mt-4 fw-bold fs-5 py-3 d-flex justify-content-center align-items-center"
                  onClick={() => handleAddTrip(QUARTERLY_RATES)}
                  disabled={!selectedState || !miles || !gallons || isAdding}
                >
                  {isAdding ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Adding...
                    </>
                  ) : (
                    "Add Trip"
                  )}
                </button>
              </div>
            ) : (
              <div>
                <h6 className="fw-bold text-secondary mb-3">Recent Entries</h6>
                <div className="custom-scroll">
                  {isFetching ? (
                    <span
                      className="loading d-flex align-items-center justify-content-center"
                      style={{ height: 200 }}
                    >
                      <i className="ri-loader-2-fill fs-25 rotation"></i>
                    </span>
                  ) : iftaDetails?.entries?.length > 0 ? (
                    iftaDetails.entries
                      .slice()
                      .reverse()
                      .map((entry) => (
                        <div
                          key={entry?.id}
                          className="border p-3 mb-2 bg-light d-flex justify-content-between"
                        >
                          <div>
                            <div className="d-flex align-items-center">
                              <span className="fw-bold fs-5 me-2">
                                {entry?.state}
                              </span>
                              <span className="badge bg-secondary">
                                {formatDate(entry?.createdAt)}
                              </span>
                            </div>
                            <small className="text-muted">
                              {entry?.miles} miles
                            </small>
                          </div>
                          <div className="text-end">
                            <small className="fw-bold">
                              {entry?.gallons} gal
                            </small>
                          </div>
                        </div>
                      ))
                  ) : (
                    <p className="text-center text-muted py-5 mb-0">
                      No entries found yet.
                      <br />
                      Add a new entry to get started.
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="bottom-tab-bar">
          <div
            className={`tab-item ${activeTab === "add" ? "active" : ""}`}
            onClick={() => setActiveTab("add")}
          >
            <Plus size={20} />
            <span>Add Trip</span>
          </div>

          <div
            className={`tab-item ${activeTab === "list" ? "active" : ""}`}
            onClick={() => {
              refetch();
              setActiveTab("list");
            }}
          >
            <FileText size={20} />
            <span>View List</span>
          </div>
        </div>
      </div>
    </div>
  );
}
